module.exports = "./img/e25c5ba49994268c1de0c27057a82711.png";